import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";
import {LonerBitmapCountUp} from "../../components/LonerBitmapCountUp";
import {Loner} from "../../Loner";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {gsap} from "gsap";
import {LonerStatics} from "../../LonerStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class LonerIndividualSymWinView extends PIXI.Container {
    private _winWays: NLCText;
    private _winAmountBitmap: LonerBitmapCountUp;
    private _winAmountNumber: number;

    constructor(winAmount: number, winWays: number, position: PIXI.Point) {
        super();
        this.visible = false;
        this._winAmountNumber = winAmount;
        this._winAmountBitmap = new LonerBitmapCountUp(16,LonerStatics.symbolWidth-20);
        this._winAmountBitmap.getCountAnimation(this._winAmountNumber, this._winAmountNumber, 0.002);
        this._winAmountBitmap.forceSetText(SlotGame.apiPlugin.currency.format(winAmount));
        this._winAmountBitmap.startFlicker();
        this._winAmountBitmap.position.set(0);

        this._winWays = new NLCText(winWays + " " + Loner.apiPlugin.translations.translate(winWays === 1 ? "Way Won" : "Ways Won").toLowerCase(), new PIXI.TextStyle({
            fontFamily: OpenSans.FAMILY,
            fill: "#EAEAEA",
            fontSize: 22,
        }));
        this._winWays.anchor.set(0.5);
        this._winWays.position.set(0, 30);
        if(this._winWays.width>LonerStatics.symbolWidth-20){
            let fontSize:number=22;
            while(this._winWays.width>LonerStatics.symbolWidth-20){
                this._winWays.setStyle(new PIXI.TextStyle({
                    fontFamily: OpenSans.FAMILY,
                    fill: "#EAEAEA",
                    fontSize: fontSize-=1,
                }))
            }
        }
        this.position = position;
        this.addChild(this._winAmountBitmap, this._winWays);
    }

    public showWinAndWays(durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                this.visible = false;
            }
        });
        tl.add(() => {
            this.visible = true;
        })
        tl.to(this, {y: this.position.y-20, duration: durr}, 0);
        tl.to(this, {alpha: 0, duration: LonerStatics.WIN_HIGHLIGHT_ANIM_DURATION-LonerStatics.WIN_HIGHLIGHT_ANIM_DURATION/1.5}, LonerStatics.WIN_HIGHLIGHT_ANIM_DURATION/1.5);
        return tl;
    }


}